import { initReactI18next } from "react-i18next";
import * as i18n from "i18next";
import enLang from "./resources/en";
import frLang from "./resources/fr";
import viLang from "./resources/vi";

export const LANG_CODES = {
  vi: 1,
  en: 2,
  fr: 3,
};
export const LANG_CODES_NAME = {
  vi: "vi",
  en: "en",
  fr: "fr",
};

export const LANG_ARR = [
  {
    label: "lbl_vietnamese",
    code: LANG_CODES_NAME.vi,
    value: LANG_CODES.vi,
  },
  {
    label: "lbl_english",
    code: LANG_CODES_NAME.en,
    value: LANG_CODES.en,
  },
  // {
  //   label: "lbl_french",
  //   code: LANG_CODES_NAME.fr,
  //   value: LANG_CODES.fr,
  // },
];

export const LANG_ARR_PRESENTATION = [
  {
    label: "Tiếng Việt",
    code: LANG_CODES_NAME.vi,
    value: LANG_CODES.vi,
  },
  {
    label: "English",
    code: LANG_CODES_NAME.en,
    value: LANG_CODES.en,
  },
  {
    label: "Français",
    code: LANG_CODES_NAME.fr,
    value: LANG_CODES.fr,
  },
];

export const DOCUMENT_SIGN_TYPES = {
  CODE: {
    CONSULTATION: 1,
    INDICATION: 2,
    PRESCRIPTION: 3,
    INDICATION_ORDER: 4,
    DISEASE_OPERATION: 5,
  },
};

const resources = {
  vi: viLang,
  en: enLang,
  fr: frLang,
};

i18n.use(initReactI18next).init(
  {
    resources,
    lng: LANG_CODES_NAME.vi,
    fallbackLng: LANG_CODES_NAME.vi, // use en if detected lng is not available
    saveMissing: true,
    interpolation: {
      escapeValue: false,
    },
  },
  err => {
    if (err) {
      return console.log(err);
    }
  }
);

export default i18n;
